module.exports = __webpack_public_path__ + "media/images/pic/brodno/hero_arrow_down-81e094479ad4503e60e627df537f7a13.png";